var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1345_5470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33341 11.3333C7.33341 10.9651 7.63189 10.6667 8.00008 10.6667C8.36827 10.6667 8.66675 10.9651 8.66675 11.3333C8.66675 11.7015 8.36827 12 8.00008 12C7.63189 12 7.33341 11.7015 7.33341 11.3333Z",
    fill: "#FF6155"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 1.83301C4.59416 1.83301 1.83325 4.59392 1.83325 7.99967C1.83325 11.4054 4.59416 14.1663 7.99992 14.1663C11.4057 14.1663 14.1666 11.4054 14.1666 7.99967C14.1666 4.59392 11.4057 1.83301 7.99992 1.83301ZM0.833252 7.99967C0.833252 4.04163 4.04188 0.833008 7.99992 0.833008C11.958 0.833008 15.1666 4.04163 15.1666 7.99967C15.1666 11.9577 11.958 15.1663 7.99992 15.1663C4.04188 15.1663 0.833252 11.9577 0.833252 7.99967ZM7.99992 4.16634C8.27606 4.16634 8.49992 4.3902 8.49992 4.66634L8.49992 9.33301C8.49992 9.60915 8.27606 9.83301 7.99992 9.83301C7.72378 9.83301 7.49992 9.60915 7.49992 9.33301L7.49992 4.66634C7.49992 4.3902 7.72378 4.16634 7.99992 4.16634Z",
    fill: "#FF6155"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1345_5470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarning);
export default __webpack_public_path__ + "static/media/alert-warning.d2f8ddcc788d2dbb10961be95868a373.svg";
export { ForwardRef as ReactComponent };